import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export type WorkflowGroup = {
  Id: string
  Description: string
}

type WorkflowGroupStore = {
  workflowGroups: WorkflowGroup[]
  resetWorkflowGroups: () => void
  setWorkflowGroup: (workflowGroup: WorkflowGroup[]) => void
  updateWorkflowGroupStored: (workflowGroup: WorkflowGroup) => void
  findWorkflowGroupById: (id: string) => WorkflowGroup | undefined
}

export const useWorkflowGroupStore = create<WorkflowGroupStore>()(
  persist(
    (set, get) => ({
      workflowGroups: [],
      resetWorkflowGroups: () => set(() => ({ workflowGroups: [] })),
      setWorkflowGroup: (workflowGroups: WorkflowGroup[]) =>
        set(() => ({ workflowGroups })),
      findWorkflowGroupById: (id: string) => {
        const { workflowGroups } = get()
        return workflowGroups.find(
          (workflowGroup: WorkflowGroup) => workflowGroup.Id === id
        )
      },
      updateWorkflowGroupStored: (workflowGroup: WorkflowGroup) =>
        set((state) => ({
          workflowGroups: state.workflowGroups.map((el) => {
            if (el.Id === workflowGroup.Id) {
              return workflowGroup
            }
            return el
          }),
        })),
    }),
    {
      name: 'workflow-groups-storage',
      storage: encryptedStorage(),
    }
  )
)
